module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/crear-sede/crear-sede.component.css
// module id = ./src/app/crear-sede/crear-sede.component.css
// module chunks = main